<template>
  <CardWithTitle
    :item-id="itemId"
    :request-status="requestStatus"
    :options-data="optionsData"
    @call-option-menu="callOptionMenu"
    @reload="$emit('reload', $event)"
  >
    <div
      ref="chartdiv"
      class="gauge-chart"
    />

    <template #top-right-slot>
      <Badge
        v-if="hasFilterApplied && isEditor"
        type="info"
        :tooltip="$t('components.Badge.label.tooltip.info')"
        :value="$t('components.Badge.label.icon.key')"
        :preset="true"
      />
    </template>
  </CardWithTitle>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core';
import cardsModel from '@/mixins/cards-model';
import gaugeModel from '@/mixins/gauge-model';
import exportModel from '@/mixins/export-model';
import CardWithTitle from '@/components/cards/models/CardWithTitle';
import Badge from '@/components/Badge';

export default {
  name: 'Gauge',
  components: {
    CardWithTitle,
    Badge,
  },
  mixins: [
    cardsModel,
    gaugeModel,
    exportModel,
  ],
  props: {
    score: {
      type: Object,
      default: () => {
        return { value: 0 };
      },
    },
    title: {
      type: String,
      required: false,
      default: '',
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    requestStatus: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      chartMin: -100,
      chartMax: 100,
      gradingData: [
        {
          title: '',
          color: '#ee1f25',
          lowScore: -100,
          highScore: -75,
        },
        {
          title: '',
          color: '#ee5757',
          lowScore: -75,
          highScore: -25,
        },
        {
          title: '',
          color: '#fdae19',
          lowScore: -25,
          highScore: 25,
        },
        {
          title: '',
          color: '#b0d136',
          lowScore: 25,
          highScore: 75,
        },
        {
          title: '',
          color: '#0f9747',
          lowScore: 75,
          highScore: 100,
        },
      ],
      matchingGrade: [],
      axis2: '',
    };
  },
  computed: {
    optionsData() {
      return this.baseCardOptions.concat(this.exportOptionsData).sort((actualOption, prevOption) => this.sortMenuOptions(actualOption, prevOption));
    },
  },
  methods: {
    setLabel() {
      const label = this.chart.radarContainer.createChild(am4core.Label);
      label.isMeasured = false;
      label.fontSize = '4em';
      label.x = am4core.percent(50);
      label.paddingBottom = -5;
      label.horizontalCenter = 'middle';
      label.verticalCenter = 'bottom';
      label.text = this.score.value.toFixed(1);
      label.fill = am4core.color(this.matchingGrade.color);
    },
  },
};
</script>

<style scoped>
  .gauge-chart {
    width: 100%;
    height: 100%;
    position: absolute;
    overflow: hidden;
  }
</style>
